
import { finishButton, nextButton, backButton } from '../tourButtons';


export const SHARED_STEPS = {
  welcome: (t) => ({
    id: 'welcome',
    title: t('tour.welcome.title'),
    text: t('tour.welcome.text'),
    buttons: [nextButton(t)],
  }),

  sidebar: (t) => ({
    id: 'sidebar',
    attachTo: {
      element: '[data-tour="sidebar"]',
      on: 'right',
    },
    title: t('tour.sidebar.title'),
    text: t('tour.sidebar.text'),
    buttons: [backButton(t), nextButton(t)],
  }),

  settings: (t) => ({
    id: 'settings',
    attachTo: {
      element: '[data-tour="nav-settings"]',
      on: 'right',
    },
    title: t('tour.settings.title'),
    text: t('tour.settings.text'),
    buttons: [backButton(t), nextButton(t)],
  }),

  help: (t) => ({
    id: 'help',
    attachTo: {
      element: '[data-tour="nav-help"]',
      on: 'right',
    },
    title: t('tour.help.title'),
    text: t('tour.help.text'),
    buttons: [backButton(t), nextButton(t)],
  }),

  done: (t) => ({
    id: 'done',
    title: t('tour.done.title'),
    text: t('tour.done.text'),
    buttons: [finishButton(t)],
  }),
};